<div class="breadcrumb-container" *ngIf="!window.location.pathname.includes('home')">
  <nav class="breadcrumb-nav" role="navigation" aria-label="Breadcrumb">
    <ol class="breadcrumb-list">
      <li class="breadcrumb-value">
        <a [routerLink]="['/home']" class="breadcrumb-link">
          <mat-icon>home</mat-icon>
          <span>Home</span>
        </a>
      </li>
      <li class="breadcrumb-value"
        *ngIf="breadcrumbService?.clubId && (window.location.pathname.includes('my-match') || window.location.pathname.includes('scheduler'))">
        <a [routerLink]="['/club', breadcrumbService.clubId]" class="breadcrumb-link">
          <mat-icon>group</mat-icon>
          <span>My Club</span>
        </a>
      </li>
      <li class="breadcrumb-value"
        *ngIf="breadcrumbService?.leagueId && window.location.pathname.includes('scheduler')">
        <a [routerLink]="['/my-match']"
          [queryParams]="{tab: 'schedule', clubId: breadcrumbService.clubId, leagueId: breadcrumbService.leagueId, leagueName: breadcrumbService.leagueName}"
          class="breadcrumb-link">
          <mat-icon>sports_tennis</mat-icon>
          <span>My Matches</span>
        </a>
      </li>
      <li class="breadcrumb-value" *ngIf="breadcrumbService?.match">
        <a [routerLink]="['/my-match']"
          [queryParams]="{tab: 'schedule', clubId: breadcrumbService.clubId,leagueId: breadcrumbService.match.leagueId, leagueName: breadcrumbService.match.leagueName}"
          class="breadcrumb-link" (click)="breadcrumbService.clearMatch()">
          <mat-icon>sports_tennis</mat-icon>
          <span>My Matches</span>
        </a>
      </li>
      <li class="breadcrumb-value active"
        *ngIf="window.location.pathname.includes('my-match') && !breadcrumbService?.match">
        <mat-icon>sports_tennis</mat-icon>
        <span>My Matches</span>
      </li>
      <li class="breadcrumb-value active" *ngIf="window.location.pathname.includes('scheduler')">
        <mat-icon>event</mat-icon>
        <span>Scheduler</span>
      </li>
      <li class="breadcrumb-value active" *ngIf="breadcrumbService?.match">
        <mat-icon>score</mat-icon>
        <span>Score Detail</span>
      </li>
    </ol>
  </nav>
</div>